function LabelMissing() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A form control does not have a corresponding label.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>If a form control does not have a properly associated text label, the function or purpose of that form control may not be presented to screen reader users. Form labels also provide visible descriptions and larger clickable targets for form controls.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>If a text label for a form control is visible, use the <code>&lt;label&gt;</code> element to associate it with its respective form control. If there is no visible label, either provide an associated label, add a descriptive title attribute to the form control, or reference the label(s) using aria-labelledby. Labels are not required for image, submit, reset, button, or hidden form controls.</p>
    </blockquote>
  )
}

export default LabelMissing